import cx from 'classnames'

import { ALLOWED_PAYMENTS } from '../../../../../../components/Basket/constants'

import './PaymentButton.scss'

const PaymentButton = ({ selected, onClick, disabled, payment }) => {
    return (
        <button
            className={cx(
                'payment-button d-flex justify-content-center align-items-center',
                payment === selected && 'active',
                disabled && 'disabled',
                payment === ALLOWED_PAYMENTS.CAFETERIA && 'pb-3'
            )}
            disabled={disabled}
            onClick={onClick}
        >
            <img src={`images/button/toggle/${payment}.svg`} alt={`${payment}`} />
        </button>
    )
}

export default PaymentButton
